import {Component, Input, OnInit, Renderer2, RendererFactory2} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DomHelperService} from 'app/global/dom-helper.service';
import {GlobalService} from 'app/global/global.service';
import {updateValue} from 'app/global/synchronize';
import {Block} from 'app/interfaces/blocks';
import {Field} from 'app/interfaces/fields';
import {Daum} from '../../settings/contentlibrary/store/content-library-store.dto';
import {ContentLibraryStoreFacade} from '../../settings/contentlibrary/store/content-library-store.facade';
import {FindAndReplaceService} from '../general-popover-settings/find-and-replace.service';
import { EditorEmitterService } from '../../events/editor-emitter.service';

interface SelectRole {
  name: string;
  id: string|number;
  color: string;
  recipient: string;
}

@Component({
  selector: 'app-content-library-tab',
  templateUrl: './content-library-tab.component.html',
  styleUrls: ['./content-library-tab.component.scss']
})
export class ContentLibraryTabComponent implements OnInit {
  @Input() uuid: string;
  public searchContent: string = '';
  public allContents = this.contentLibraryFacade$.allContents$;
  public fetchContentLibraryRequestState = this.contentLibraryFacade$.fetchContentLibraryRequestState$;
  private renderer: Renderer2;
  public selectRole: SelectRole[] = [
      { name: this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender"), id: "0", color: '#28c76f', recipient: '' },
      { name: this._translocoService.translate("Field setting anyone (Template/Document - section) - Anyone"), id: "-1", color: '#28c76f', recipient: '' }
  ];
  constructor(
    private contentLibraryFacade$: ContentLibraryStoreFacade,
    private globalService: GlobalService,
    private domHelperService: DomHelperService,
    rendererFactory: RendererFactory2,
    public activeModal: NgbActiveModal,
    public findAndReplaceService: FindAndReplaceService,
    public _translocoService: TranslocoService,
    public editorEmitterService: EditorEmitterService,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  ngOnInit(): void {
    this.contentLibraryFacade$.fetchAllContentLibraries('all');
  }

  selectContentLibrary(content: Daum) {
    const appendFields = [];
    const parentContent = document.querySelector(`[uuid="${this.uuid}"]`).closest('.content-library-block');
    const cleanedHtmlContent = content.content.replace(/\\|\n/g, '');
    parentContent.outerHTML = cleanedHtmlContent;
    const field_data = { ...content.fields_datas.data };
    for (const field in field_data) {
      const fieldData:Field = { ...field_data[field] };
      const unassignedField = { ...fieldData};
      if (field == "blocks") {
        for (const block in field_data["blocks"]) {
          const blockData: Block = { ...field_data["blocks"][block] };
          if (["content-box"].includes(blockData.type)) {
            const role_id = this.findRole(blockData.role_id);
            blockData.role_id = role_id;
          }else if(["attachment","upload-pdf"].includes(blockData.type)){
            const role_id = this.findRole(blockData.request_from);
            blockData.request_from = role_id;
          }
          this.globalService.fields_data["blocks"] = { ...this.globalService.fields_data["blocks"], ...{[blockData.uuid]:blockData} };
        }
        continue;
      }
        const role_id = this.findRole(fieldData.selected_for_role_id);
        fieldData.selected_for_role_id = role_id;
        if(!role_id && document.querySelector(`.drag-fields[uuid="${fieldData.uuid}"]`)){
          appendFields.push(unassignedField);
        }
        const updateFieldRoleAndType = (roleField) => {
          const role = this.globalService.roles.find(role => role.role_name === fieldData.selected_field_role_id);
          if (role) {
            fieldData.selected_field_role_id = role.id;
            const customField = {...role[roleField].find(item => item.key === fieldData?.content_library_selected_field_type)};
            if (Object.keys(customField).length > 0) {
              fieldData.selected_field_type_id = customField.id;
              fieldData.prefixid = String(customField.id);
              if(role.recipient_id){
                if(customField.key === 'first_name'){
                    customField.value = `${role.recipient.firstname} ${role.recipient.lastname ?? ''}`
                }
                updateValue(fieldData.uuid, customField.value, this.globalService);
              }
            }
          }
        };

        if (fieldData.field_section === "person_field") {
          updateFieldRoleAndType('personfields');
        }

        if (fieldData.field_section === "org_field") {
          updateFieldRoleAndType('orgfields');
        }
      const fieldExists = this.globalService.findField(this.globalService.fields_data, 'selected_field_type_id', fieldData.selected_field_type_id, fieldData.field_section);
      this.globalService.fields_data[field] = fieldData;
      if(fieldExists && Number(fieldData?.selected_field_type_id) !== 0){
        this.findAndReplaceService.findAndReplace(fieldData.uuid, fieldExists).subscribe();
      }
    }
    this.editorEmitterService.triggerEmitter({ initDefaultEditorEvents:true });
    this.activeModal.close({status:'success', result:appendFields});
  }

  findRole(name:string|number){
    const roles =  this.globalService.roles;
    const foundRole = roles.concat(this.selectRole).find(role => role.role_name === name || role.id == name);
    return foundRole !== undefined ? foundRole?.id : null;
  }

}
